import type React from "react"

import type { BoxProps } from "./Box"

import { Box } from "./Box"

/**
 * A component that centers its children.
 */
export function Center(props: BoxProps): React.JSX.Element {
  return (
    <Box
      alignItems={"center"}
      display={"flex"}
      justifyContent={"center"}
      w={"$full"}
      {...props}
    />
  )
}
